import React from 'react'
import Select from '../../../_library/Select'

const options_quantity_customers = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: 1000, label: '1000' },
  { value: 5000, label: '5000' },
  { value: 'all', label: 'All' },
]

const TopCustomerRegularTickets = ({
  values,
  ticketTableLabel,
  optionsTickets,
  errors,
  touched,
  options_quantity,
  handleChangeTicketTypeID,
  handleChangeQuantity,
  handleTopCustomersQuantity,
}) => (
    <>
      <div>
        <div className="row">
          <div className="col-xs-6 col-12">
            <Select
              id="defaultTicketTypeID"
              label={ticketTableLabel}
              options={optionsTickets}
              value={values.defaultTicketTypeID}
              error={errors.defaultTicketTypeID}
              touched={touched.defaultTicketTypeID}
              onSelect={option => handleChangeTicketTypeID(option)}
            />
          </div>
          <div className="col-xs-6 col-12">
            <Select
              id="defaultTicketQuantity"
              label="Ticket/Table Quantity"
              options={options_quantity}
              value={values.quantity}
              onChange={handleChangeQuantity}
            />
          </div>
        </div>
      </div>
      <div className='row'>
        <div className="col-xs-6 col-12">
          <Select
            id="quantityTopCustomers"
            label="Top Customers Quantity"
            options={options_quantity_customers}
            value={values.quantityTopCustomers}
            onChange={e => handleTopCustomersQuantity(e.target.value)}
          />
        </div>
      </div>
    </>
  )

export default TopCustomerRegularTickets
